import { observer } from 'mobx-react-lite';
import { Virtuoso } from 'react-virtuoso';
import { LoadingQueueRow } from './loading-queue-row';
import { QueueVirtuosoListWrapper } from './queue-virtuoso-list-wrapper';

export const LoadingQueueRows = observer(function LoadingQueueRows(): React.ReactElement {
    return (
        <Virtuoso
            key="list"
            style={{
                height: '100%',
                width: '100%',
            }}
            totalCount={50}
            components={{ List: QueueVirtuosoListWrapper }}
            computeItemKey={(index: number) => index}
            itemContent={() => <LoadingQueueRow />}
            data-testid="LOADING_QUEUE_ROWS"
        />
    );
});
